import { render, staticRenderFns } from "./MentionsSection.vue?vue&type=template&id=451b12fa&scoped=true"
import script from "./MentionsSection.vue?vue&type=script&lang=js"
export * from "./MentionsSection.vue?vue&type=script&lang=js"
import style0 from "./MentionsSection.vue?vue&type=style&index=0&id=451b12fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b12fa",
  null
  
)

export default component.exports